import { getCookie } from "utils/cookies/cookies";

export function getJWTToken() {
  return getCookie('token')
}
